var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    staticClass: "wrap--sub"
  }, [_c('sub-visual', {
    attrs: {
      "visual": '전자제조지원센터'
    }
  }), _c('div', {
    staticClass: "tab-list--primary-wrap"
  }, [_c('ul', {
    staticClass: "tab-list tab-list--primary"
  }, [_c('li', [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("센터개요")])], 1), _c('li', [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/about/equipments"
    }
  }, [_vm._v("장비소개")])], 1), _c('li', {
    staticClass: "on"
  }, [_c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/about/location"
    }
  }, [_vm._v("오시는 길")])], 1)])]), _c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('tit-primary', {
    attrs: {
      "sc": "오시는길을 안내해드립니다",
      "tit": "한국전자정보통신산업진흥회에 오신 걸 환영합니다."
    }
  }), _c('div', {
    staticClass: "rounded mb-50 mb-lg-80"
  }, [_c('iframe', {
    staticClass: "d-block",
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3163.9226635860596!2d126.95866385116791!3d37.53332027970516!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca2044a851009%3A0x8c6a3c15fd3de146!2z7ISc7Jq47Yq567OE7IucIOyaqeyCsOq1rCDtlZzqsJXroZwz6rCAIDE2LTIw!5e0!3m2!1sko!2skr!4v1633684512789!5m2!1sko!2skr",
      "width": "100%",
      "height": "520",
      "allowfullscreen": "",
      "loading": "lazy"
    }
  })]), _c('ul', {
    staticClass: "border-top border-2 border-color-black page-text pt-lg-20 page-text"
  }, [_c('li', {
    staticClass: "py-12 py-md-30 py-lg-34 border-bottom"
  }, [_c('p', {
    staticClass: "font-weight-bold mb-4 mb-lg-10"
  }, [_vm._v(" 한국전자정보통신산업진흥회 ")]), _c('p', {
    staticClass: "color-grey"
  }, [_vm._v(" 서울시 용산구 청파로77 원효전자상가6동 3층 ‘용산전자상상가’ ")])]), _c('li', {
    staticClass: "py-12 py-md-30 py-lg-34 border-bottom"
  }, [_c('p', {
    staticClass: "font-weight-bold mb-4 mb-lg-10"
  }, [_vm._v(" 지하철 노선 안내 ")]), _c('div', [_c('div', {
    staticClass: "d-flex align-center mb-6 mb-lg-14"
  }, [_c('div', {
    staticClass: "rounded-tit d-flex align-center justify-center text-center line-height-1 mr-8 mr-lg-16",
    staticStyle: {
      "background-color": "#2d53a8"
    }
  }, [_c('p', {
    staticClass: "page-text--sm color-white"
  }, [_vm._v("1호선")])]), _c('p', {
    staticClass: "color-grey"
  }, [_c('strong', {
    staticClass: "font-weight-bold"
  }, [_vm._v("용산역 1호선 3번 출구")]), _vm._v("와 직접 연결된 통로로 진입, 도보 8분 ")])]), _c('div', {
    staticClass: "d-flex align-center mb-6 mb-lg-14"
  }, [_c('div', {
    staticClass: "rounded-tit d-flex align-center justify-center text-center line-height-1 mr-8 mr-lg-16",
    staticStyle: {
      "background-color": "#3c66ae"
    }
  }, [_c('p', {
    staticClass: "page-text--sm color-white"
  }, [_vm._v("4호선")])]), _c('p', {
    staticClass: "color-grey"
  }, [_c('strong', {
    staticClass: "font-weight-bold"
  }, [_vm._v("신용산역 4호선 4번 출구")]), _vm._v("에서 도보 약 14분 거리 ")])]), _c('div', {
    staticClass: "d-flex align-center"
  }, [_c('div', {
    staticClass: "rounded-tit d-flex align-center justify-center text-center line-height-1 mr-8 mr-lg-16",
    staticStyle: {
      "background-color": "#96572c"
    }
  }, [_c('p', {
    staticClass: "page-text--sm color-white"
  }, [_vm._v("6호선")])]), _c('p', {
    staticClass: "color-grey"
  }, [_c('strong', {
    staticClass: "font-weight-bold"
  }, [_vm._v("효창공원역 6호선 3번 출구")]), _vm._v("에서 도보 약 16분 거리 ")])])])]), _c('li', {
    staticClass: "py-12 py-md-30 py-lg-34 border-bottom"
  }, [_c('p', {
    staticClass: "font-weight-bold mb-4 mb-lg-10"
  }, [_vm._v(" 버스 노선 안내 ")]), _c('div', {
    staticClass: "color-grey"
  }, [_c('p', {
    staticClass: "line-txt mb-2 mb-lg-4"
  }, [_vm._v(" - 용산전자상가 10동 정류장 하차 - (간선) "), _c('span', {
    staticStyle: {
      "color": "#005b9f"
    }
  }, [_vm._v("■")]), _vm._v("505, (지선) "), _c('span', {
    staticStyle: {
      "color": "#0f9f00"
    }
  }, [_vm._v("■")]), _vm._v("5012 ")]), _c('p', {
    staticClass: "line-txt mb-2 mb-lg-4"
  }, [_vm._v(" - 용산전자상가 12동 정류장 하차 - (간선) "), _c('span', {
    staticStyle: {
      "color": "#005b9f"
    }
  }, [_vm._v("■")]), _vm._v("505, (지선) "), _c('span', {
    staticStyle: {
      "color": "#0f9f00"
    }
  }, [_vm._v("■")]), _vm._v("5012 ")]), _c('p', {
    staticClass: "line-txt"
  }, [_vm._v(" - 신용산, 지하차도 정류장 하차 - (간선) "), _c('span', {
    staticStyle: {
      "color": "#005b9f"
    }
  }, [_vm._v("■")]), _vm._v("404, (지선) "), _c('span', {
    staticStyle: {
      "color": "#0f9f00"
    }
  }, [_vm._v("■")]), _vm._v("0017, "), _c('span', {
    staticStyle: {
      "color": "#0f9f00"
    }
  }, [_vm._v("■")]), _vm._v("5012 ")])])]), _c('li', {
    staticClass: "pt-12 pt-md-30 pt-lg-34"
  }, [_c('p', {
    staticClass: "font-weight-bold mb-4 mb-lg-10"
  }, [_vm._v(" 주차장 안내 ")]), _c('div', {
    staticClass: "color-grey"
  }, [_c('p', {
    staticClass: "line-txt mb-2 mb-lg-4"
  }, [_vm._v(" - 원효전자상가 주차장 - 서울시 용산구 원효로 3가 51-30 ")]), _c('p', {
    staticClass: "line-txt"
  }, [_vm._v(" - 공영주차장 - 서울시 용산구 신계동 42-1 ")])])])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }